import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import i18n from '../../../i18n';
import Spinner from '../../../components/Spinner';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Datepicker from 'react-tailwindcss-datepicker';
import {getEstadosProposta, getPropostas, getRepresentantes, getTiposPropostas} from '../../../pages/requests';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';
import NotFound from '../../NotFound';
import SelectComponent from '../../Selects/SelectComponentFilt';
import moment from 'moment';
import MultiSelect from '../../Selects/MultiSelectComponent';
import {verifAuthenticated} from '../../../Services/API';
import LoadingModal from '../../LoadingModal';
import {Collapse, initTE} from 'tw-elements';
import axios from 'axios';
import {toast} from 'react-toastify';

function Table({
    onRowClick,
    filtroCodigo,
    setFiltroCodigo,
    filtroTipo,
    setFiltroTipo,
    filtroDt,
    setFiltroDt,
    filtroCliente,
    setFiltroCliente,
    filtroEstado,
    setFiltroEstado,
    filtroRepresentantes,
    setFiltroRepresentantes,
    filtroLinhas,
    setFiltroLinhas,
    tipos,
    estados,
    representantes,
    filtroDescNegocio,
    setFiltroDesNegocio,
    filtroEncomenda,
    setFiltroEncomenda,
}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {acessos, utilizador, rep, userRepresentante, isCard, openCards} = useContext(Context);
    //const history = useHistory();
    const {t} = useTranslation();
    const [totalItems, setTotalItems] = useState(0);
    const [sorting, setSorting] = useState({field: '', order: ''});
    const [currentPage, setCurrentPage] = useState(1);

    const [acessoR, setAcessoR] = useState([]);
    const [loading, setLoading] = useState(true);

    const [propostas, setPropostas] = useState([]);
    const [totalRegistos, setTotalRegistos] = useState(0);
    // const [semDados, setSemDados] = useState(false);
console.log(filtroTipo, "filtro");
    // // FILTROS
    // const [tipos, setTipos] = useState([]);
    // const [estados, setEstados] = useState([]);
    // const [representantes, setRepresentantes] = useState([]);

    // const [filtroTipo, setFiltroTipo] = useState(null);
    // const [filtroDt, setFiltroDt] = useState({startDate: null, endDate: null});
    // const [filtroCliente, setFiltroCliente] = useState('');
    // const [filtroEstado, setFiltroEstado] = useState(null);
    // const [filtroRepresentantes, setFiltroRepresentantes] = useState([]);
    // const [filtroLinhas, setFiltroLinhas] = useState('');

    function HandleSpinner() {
        {
            <Spinner />;
        }
    }

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    initTE({Collapse});

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const ITEMS_PER_PAGE = 15;

    useEffect(() => {
        acessos.forEach(element => {
            if (element.funcao == 'GESSQH') {
                const acesso = {
                    funcao: element.funcao,
                    consultar: element.consultar,
                    apagar: element.apagar,
                    modificar: element.modificar,
                    criar: element.criar,
                };
                setAcessoR(acesso);
            }
        });
    }, [acessos]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(async () => {
        window.scrollTo(0, 0);

        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setPropostas([]);

        setLoading(true);
        getPropostas(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroCodigo,
            filtroTipo?.value ?? '',
            filtroDt.startDate,
            filtroDt.endDate,
            filtroCliente,
            filtroDescNegocio,
            filtroRepresentantes.map(r => r.value),
            filtroEstado?.value,
            filtroEncomenda?.value
        )
            .then(res => {
                if (res.data.success) {
                    setPropostas(res.data.propostas);
                    setTotalRegistos(res.data.totalRegistos);
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroCodigo, filtroTipo, filtroDescNegocio, filtroDt, filtroCliente, filtroEstado, filtroRepresentantes, filtroEncomenda]);

    //

    function limparFiltros() {
        setFiltroTipo(null);
        setFiltroDt({startDate: null, endDate: null});
        setFiltroCliente('');
        setFiltroDesNegocio('');
        setFiltroEstado(null);
        setFiltroRepresentantes([]);
        setFiltroLinhas('');
        setCurrentPage(1);
    }

    return (
        <div>
            {isMobile || isCard ? (
                <div>
                    {propostas?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row" onClick={() => onRowClick(dados)}>
                                        {dados.cliente.codigoCliente} - {dados.cliente.nomeCliente}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('tipo')}:</div> {dados.tipoOrcamento.label}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('negocio')}:</div> {dados.negocio.nome}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('data')}: </div> {moment(dados.data).format(FORMATO_DATA)}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.cliente.nomeCliente}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('estado')}: </div> {dados.estado.label}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {dados.representante.label}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}
                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('numOrcamento')}
                                    <InputFilter
                                        value={filtroCodigo}
                                        onSearch={value => {
                                            setFiltroCodigo(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('tipoOrcamento')}
                                    <SelectComponent
                                        options={tipos}
                                        value={filtroTipo ? filtroTipo?.label : ''}
                                        onChange={e => {
                                            setFiltroTipo(e?.label);
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('negocio')}
                                    <InputFilter
                                        value={filtroDescNegocio}
                                        onSearch={value => {
                                            setFiltroDesNegocio(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('data')}
                                    <Datepicker
                                        displayFormat={FORMATO_DATA}
                                        useRange={false}
                                        asSingle={false}
                                        value={filtroDt}
                                        onChange={newValue => {
                                            setFiltroDt(newValue);
                                            setCurrentPage(1);
                                        }}
                                        inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('cliente')}
                                    <InputFilter
                                        value={filtroCliente}
                                        onSearch={value => {
                                            setFiltroCliente(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('estado')}
                                    <SelectComponent
                                        options={estados}
                                        value={filtroEstado}
                                        onChange={e => {
                                            setFiltroEstado(e);
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>

                                <th scope="col" className="px-6 py-3">
                                    {t('representante')}
                                    <div className="flex flex-row">
                                        <MultiSelect
                                            options={representantes}
                                            value={filtroRepresentantes}
                                            onChange={e => {
                                                setFiltroRepresentantes(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                        {(filtroCliente || filtroDt.startDate || filtroEstado || filtroTipo) && (
                                            <button
                                                onClick={limparFiltros}
                                                type="button"
                                                className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                <FilterAltOffIcon />
                                            </button>
                                        )}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {propostas?.map(dados => (
                                <tr
                                    className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400"
                                    onClick={() => onRowClick(dados)}>
                                    <td className="px-6 py-1">{dados.id}</td>
                                    <td className="px-6 py-1">{dados.tipoOrcamento.label}</td>
                                    <td className="px-6 py-1">{dados.negocio.nome}</td>
                                    <td className="px-6 py-1">{moment(dados.data).format(FORMATO_DATA)}</td>
                                    <td className="px-6 py-1">{dados.cliente.nomeCliente}</td>
                                    <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.estado.label}</td>
                                    <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.representante.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* {semDados && !loading && <NotFound frase={t('semRegistos')} />} */}
                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            )}
        </div>
    );
}

export default Table;
